import PropTypes from "prop-types";
import React from "react";
import { useStylesLanding } from "../../utils/mantine/useStylesLanding";
import { Box, Flex, Image, Text, useMantineTheme } from "@mantine/core";

const VerifiableData = ({ staticBasePath }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  const { classes: landingClasses } = useStylesLanding();
  return (
    <Box component="section" className={landingClasses.landingThree}>
      <Box className={landingClasses.landingContainer}>
        <Box className={landingClasses.landingThreeTitle}>
          Verifiable Data Integrity with vBase Stamper
        </Box>
        <Text className={landingClasses.landingThreeText}>
          vBase offers a blockchain-powered solution for anyone needing a
          trusted timestamp for their data. A vBase stamp ensures your data
          remains trustworthy forever.
        </Text>

        <Flex
          className={landingClasses.landingThreeBlocks}
          justify={theme.flex.justify.between}
        >
          <Box className={landingClasses.landingThreeBlocksItem}>
            <Box className={landingClasses.landingThreeBlocksItemContent}>
              <Image
                src={`${staticBasePath}public/images/svg/landing_authenticated _proof.svg`}
                alt="Authenticated Proof"
              />
              <Text component="span">Authenticated Proof</Text>
              <Text>
                vBase offers a reliable approach for verifying the authenticity
                of data, enhancing trust.
              </Text>
            </Box>
          </Box>
          <Box className={landingClasses.landingThreeBlocksItem}>
            <Box className={landingClasses.landingThreeBlocksItemContent}>
              <Image
                src={`${staticBasePath}public/images/svg/landing_proof_of_existence.svg`}
                alt="Proof of Existence"
              />
              <Text component="span">Proof of Existence</Text>
              <Text>
                Establish what data you had when, and who stamped it. Create an
                unchangeable verifiable digital history.
              </Text>
            </Box>
          </Box>
          <Box className={landingClasses.landingThreeBlocksItem}>
            <Box className={landingClasses.landingThreeBlocksItemContent}>
              <Image
                src={`${staticBasePath}public/images/svg/landing_simple_long_lived.svg`}
                alt="Proof of Existence"
              />
              <Text component="span">Simple and Long-lived</Text>
              <Text>
                No receipts to keep. No 3rd party dependencies. Use blockchain
                to create a permanent record that is verifiable even if vBase
                disappears.
              </Text>
            </Box>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
VerifiableData.propTypes = {
  staticBasePath: PropTypes.string.isRequired,
};
export default VerifiableData;
